/**
 * The managers a new project starts with: the market's default managers who are still org members, or else the
 * current user when they are one. Anyone else would be rejected by the server.
 */
export const getInitialProjectManagerIds = (defaultManagerIds: string[] | undefined, orgUserIds: string[], currentUserId: string | undefined): string[] => {
  const orgUserIdSet = new Set(orgUserIds);
  const defaults = (defaultManagerIds ?? []).filter(id => orgUserIdSet.has(id));
  if (defaults.length > 0) return defaults;
  return currentUserId && orgUserIdSet.has(currentUserId) ? [currentUserId] : [];
};
